import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { teal } from '../colors';

var createClassNames = function createClassNames(classNamesObject) {
  var classNames = [];
  Object.keys(classNamesObject).forEach(function (key) {
    if (classNamesObject[key]) {
      classNames.push(key);
    }
  });
  return classNames.join(' ');
};

var CarouselSlide = function CarouselSlide(_ref) {
  var active = _ref.active,
      animateIn = _ref.animateIn,
      animateOut = _ref.animateOut,
      direction = _ref.direction,
      index = _ref.index,
      onCarouselClick = _ref.onCarouselClick,
      showZoomOverlay = _ref.showZoomOverlay,
      zoomOverlayContent = _ref.zoomOverlayContent,
      props = _objectWithoutProperties(_ref, ["active", "animateIn", "animateOut", "direction", "index", "onCarouselClick", "showZoomOverlay", "zoomOverlayContent"]);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentDirection = _useState2[0],
      setDirection = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      classes = _useState4[0],
      setClasses = _useState4[1];

  var startAnimation = useCallback(function () {
    var newDirection = direction === 'prev' ? 'right' : 'left';
    setDirection(newDirection);
  }, [direction, setDirection]);
  useEffect(function () {
    var initialClasses = {
      item: true,
      clickable: onCarouselClick && active && !animateIn,
      active: active && !animateIn || animateOut,
      'overlay-container': showZoomOverlay
    };

    if (direction && active && animateIn) {
      initialClasses[direction] = true;
    }

    if (currentDirection && (animateIn || animateOut)) {
      initialClasses[currentDirection] = true;
    }

    setClasses(initialClasses);
  }, [onCarouselClick, active, animateIn, animateOut, showZoomOverlay, direction, currentDirection]);
  useEffect(function () {
    setDirection(null);
    setTimeout(function () {
      return startAnimation();
    }, 20);
  }, [active, startAnimation]);

  var onClick = function onClick() {
    onCarouselClick && onCarouselClick(index);
  };

  var zoomContent = zoomOverlayContent || React.createElement("span", null, "Zoom In");
  return React.createElement("div", {
    onClick: onClick,
    className: createClassNames(classes)
  }, props.children, showZoomOverlay ? React.createElement("div", {
    className: "overlay flex-center",
    style: {
      color: teal.base
    }
  }, zoomContent) : null);
};

CarouselSlide.propTypes = {
  active: PropTypes.bool,
  index: PropTypes.number,
  animateOut: PropTypes.bool,
  animateIn: PropTypes.bool,
  direction: PropTypes.string,
  onCarouselClick: PropTypes.func,
  showZoomOverlay: PropTypes.bool,
  zoomOverlayContent: PropTypes.node,
  children: PropTypes.node
};
export default CarouselSlide;